import React, { useEffect, useMemo, useState } from 'react'
import { useMeet } from '../../../contexts/meeting.context';
import { createCn } from '../../../helpers/utils';
import classes from '../styles.module.scss';
import { EndCallIcon, MicIcon, MicOffIcon, ShareScreenIcon, VidIcon, VidOffIcon } from '../../../assets';
import { useNavigate } from 'react-router-dom';


const cn = createCn('current-call', classes);

const CurrentCall = () => {
  const navigate = useNavigate();

  const [show, setShow] = useState(false);


  const {
    callActive,
    meJoined,
    shareOn,
    endCall,
    micOn,
    videoOn,
    toggleMic,
    toggleVideo,
    toggleShare,
  } = useMeet();

  const bars = useMemo(
    () => Array.from({ length: 25 }, () => Math.random() * (2.375 - 0.5) + 0.5),
    []
  );

  useEffect(() => {
    setShow(callActive && meJoined && !window.location.pathname.includes('/meeting'));
  }, [callActive, meJoined, window.location.pathname]);

  if (!show) {
    return null;
  }

  return (
    <div className={cn()} onClick={(e) => {
      if (e.target === e.currentTarget) {
        e.stopPropagation();
        setShow(!show);
        navigate('/meeting');
      }
    }}>
      <div className={cn('bars')}>
        {bars.map((height, i) => (
          <div
            key={i}
            className={cn('bar')}
            style={{
              height: `${height}rem`,
            }}
          ></div>
        ))}
      </div>
      {show && <div className={cn('controls')}>
        <div className={cn('control-item', { active: micOn })} onClick={toggleMic}>
          {micOn ? <MicIcon /> : <MicOffIcon />}
        </div>
        <div className={cn('control-item', { active: videoOn })} onClick={toggleVideo}>
          {videoOn ? <VidIcon /> : <VidOffIcon />}
        </div>
        <div className={cn('control-item', { green: shareOn })} onClick={toggleShare}>
          {<ShareScreenIcon />}
        </div>
        <div className={cn('control-item', { red: true })} onClick={endCall}>
          {<EndCallIcon />}
        </div>

      </div>}
    </div>
  )
}

export default CurrentCall